:host {
    @include grid;

    padding: 48px 0 42px;
}

.content-wrapper {
    grid-column: 2 / -2;
    display: grid;
    column-gap: var(--column-gap);
    row-gap: 40px;
    grid-template-columns: 1fr 1fr 2fr;
    align-items: end;
}

::slotted(sew-ws-richtext) {
    justify-self: end;
}

@include mq-2-5 {
    .content-wrapper {
        grid-template-columns: 1fr 1fr 1fr;
    }
}

@include mq-2 {
    .content-wrapper {
        grid-template-columns: 1fr 1fr;
    }

    ::slotted(sew-ws-richtext) {
        justify-self: start;
    }
}

@include mq-2 {
    .content-wrapper {
        display: block;
    }

    ::slotted(sew-ws-linklist) {
        margin-bottom: 12px;
    }

    ::slotted(sew-ws-richtext) {
        justify-self: start;
        margin-top: 40px;
    }
}
